import envVar from '../config/envVars';
import httpGet from './httpClient/httpGet';
import httpPost from './httpClient/httpPost';
import { LateFeeConfigProps } from '../modules/LateFeeConfig/types';
import authenticationUtils from '../utils/authenticationUtils';

const getLateFeeConfigBySchool = async (school: string) =>
  httpGet(`${envVar.REACT_APP_PAYMENTS_API_BASE_URL}/late-fee/${school}`, {
    headers: {
      Authorization: `Bearer ${authenticationUtils.getEasypayToken()}`
    }
  });

const upsertLateFeeConfig = async (data: LateFeeConfigProps) =>
  httpPost(`${envVar.REACT_APP_PAYMENTS_API_BASE_URL}/late-fee/`, data, {
    headers: {
      Authorization: `Bearer ${authenticationUtils.getEasypayToken()}`
    }
  });

export { upsertLateFeeConfig, getLateFeeConfigBySchool };
